import { combineReducers } from 'redux';
import bundlesReducer from './bundlesSlice';

export default combineReducers({
  bundles: bundlesReducer
})
